export enum Severity {
	DEFAULT = 'default',
	ERROR = 'error',
	INFO = 'info',
	PRIMARY = 'primary',
	SECONDARY = 'secondary',
	SUCCESS = 'success',
	WARNING = 'warning',
}

export const SEVERITIES = Object.values(Severity);
